import Image from 'next/image';
import classNames from 'classnames';
import Link from 'next/link';
import { useReactiveVar } from '@apollo/client';

import { getFestival } from '@utils/datetime';

import style from './index.module.less';
import { companyShortNameVar } from '@apolloClient/reactiveVars';

interface LogoProps {
  className?: string;
  color?: string;
}

function getLogo() {
  let headerLogo = '/images/logo-header.png';

  if (getFestival() === 'chrismas') headerLogo = '/images/logo-chrismas.svg';
  if (getFestival() === 'tet') headerLogo = '/images/tet-2023/Logo.png';

  return headerLogo;
}

export default function Logo({ className }: LogoProps) {
  const companyShortName = useReactiveVar(companyShortNameVar);
  const logoHref = companyShortName === 'unknown' ? '/' : `/${companyShortName}`;

  const currLogo = getLogo();

  return (
    <Link href={logoHref} passHref>
      <a>
        <div className={classNames(className, style.logo)}>
          <Image src={currLogo} layout="fill" objectFit="contain" />
        </div>
      </a>
    </Link>
  );
}
